import { Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface AssignDeviceCalloutProps {
    /** e.g. "No Buttons Assigned", "No Pendants Assigned". */
    label: string;
    onAssign: () => void;
    /** Hide the Assign button when the user can't manage devices. */
    showAssignButton?: boolean;
    assignLabel?: string;
}

/**
 * Presentational empty-state row prompting the user to assign a device.
 * Callers own the navigation and analytics via `onAssign` so the same row can
 * back different assignment flows (unit buttons, resident pendants, door sensors).
 */
export default function AssignDeviceCallout({
    label,
    onAssign,
    showAssignButton = true,
    assignLabel = 'Assign',
}: AssignDeviceCalloutProps) {
    const { shape, spacing } = useTheme();

    return (
        <Stack
            direction="row"
            sx={{
                width: '100%',
                p: 2,
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: shape.borderRadiusXl,
                bgcolor: 'common.white',
                minHeight: spacing(7.5),
            }}
        >
            <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'grey.900' }}>
                {label}
            </Typography>

            {showAssignButton && (
                <Button color="primary" variant="contained" size="small" onClick={onAssign}>
                    {assignLabel}
                </Button>
            )}
        </Stack>
    );
}
